import React from "react";
import T from "prop-types";
import { Field, Fields, FormSection } from "redux-form";
import { FormInput, Select } from "MODULES/shared/components/Forms";
import FormRow from "MODULES/shared/components/Forms/FormRow";
import {
  CARE_OF,
  CITY,
  COMPANY_NAME,
  CONTACT_NAME,
  COUNTRY,
  LINE1,
  LINE2,
  POSTAL_CODE,
  STATE
} from "APP_ROOT/constants";
import { Col } from "react-bootstrap";
import countries from "LIB/countries";
import { properCase } from "LIB/formatters/text";
import RestrictedAddressWarning from "MODULES/shared/components/RestictedAddressWarning/RestrictedAddressWarning";
import State from "./State";

const countryOptions = countries.map(c => ({
  value: c.code,
  text: c.name
}));

export default function ShipToOther({
  getField,
  section = "ship_to_shipping_address"
}) {
  const addressFields = getField
    ? [LINE1, CITY, STATE, POSTAL_CODE, COUNTRY].reduce(
        (final, f) => ({
          ...final,
          [f]: getField(`${section}.${f}`)
        }),
        {}
      )
    : {};

  return (
    <FormSection name={section}>
      <FormRow>
        <Col md={6}>
          <Field
            name={COMPANY_NAME}
            component={FormInput}
            label={properCase(COMPANY_NAME)}
            required
          />
        </Col>
        <Col md={6}>
          <Field name={CARE_OF} component={FormInput} label="C/O" />
        </Col>
      </FormRow>
      <FormRow>
        <Col md={6}>
          <Field
            name={COUNTRY}
            component={Select}
            label={properCase(COUNTRY)}
            options={countryOptions}
            required
          />
        </Col>
        <Col md={6}>
          <Field
            name={CONTACT_NAME}
            component={FormInput}
            label={properCase(CONTACT_NAME)}
            options={countryOptions}
          />
        </Col>
      </FormRow>
      <FormRow>
        <Col md={6}>
          <Field
            name={LINE1}
            component={FormInput}
            label="Address Line 1"
            required
          />
        </Col>
        <Col md={6}>
          <Field name={LINE2} component={FormInput} label="Address Line 2" />
        </Col>
      </FormRow>
      <FormRow>
        <Col md={4}>
          <Field
            name={CITY}
            component={FormInput}
            label={properCase(CITY)}
            required
          />
        </Col>
        <Col md={4}>
          <Fields names={[COUNTRY, STATE]} component={State} />
        </Col>
        <Col md={4}>
          <Field
            name={POSTAL_CODE}
            component={FormInput}
            label="Zip/Postal Code"
            required
          />
        </Col>
      </FormRow>
      <FormRow>
        <Col md={12}>
          <RestrictedAddressWarning {...addressFields} />
        </Col>
      </FormRow>
    </FormSection>
  );
}

ShipToOther.propTypes = {
  section: T.string
};



// WEBPACK FOOTER //
// ./app/modules/shared/components/ShippingSection/ShipToOther.jsx